import { render } from "./index.vue?vue&type=template&id=3716aa0d&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=3716aa0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3716aa0d"

export default script